module.exports = __webpack_public_path__ + "img/pen-tool-01.05ca3510.svg";